module.exports = __webpack_public_path__ + "static/media/podium_levels.183b4a78.png";